export default __webpack_public_path__ + "static/media/grey-Bg.f201d455.png";